/**
 * Shared methods used to interact with the vue router.
 *
 * @vuedoc
 * @exports mixins/router
 * @category Services
 */

export default {
  methods: {
    /**
     * Push passed parameters to the $router.
     *
     * @param {string} param
     * @param {string|number} value
     */
    updateQueryParams(param, value) {
      this.$router.push({
        query: {
          ...this.$route.query,
          [param]: value,
        },
      });
    },
    /**
     * Push sort direction and prop parameters to the $router.
     *
     * @param {object} payload
     * @param {string} payload.sortDirection
     * @param {string} payload.sortProp
     */
    changeSortCriteria({ sortDirection, sortProp }) {
      this.$router.push({
        query: {
          ...this.$route.query,
          sortDirection,
          sortProp,
        },
      });
    },
  },
};
